import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postLogin } from "../../redux/actions/actionLogin";

export default function Login() {
  const formLogin = {
    user: "",
    pass: "",
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState(formLogin);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  
  

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postLogin(form))
    setForm({
        user: "",
        pass: "",
    });    
  };

  useEffect(() => {
    if(isAuthenticated){
      navigate("/")
    }
    
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-w-full bg-gray-900">
      <form onSubmit={handleSubmit}>
        <div>
          <div>
            <div>
              <label className="text-white">Nombre de Usuario</label>
            </div>
            <input
              className="border rounded"
              type="text"
              name="user"
              value={form.user}
              onChange={handleChange}
              required={true}
            />
          </div>
          <div>
            <div>
              <label className="text-white">Contraseña</label>
            </div>
            <input
              className="border rounded"
              type="password"
              name="pass"
              value={form.pass}
              onChange={handleChange}
              required={true}
            />
          </div>
          <div>
            <button className="mt-12 p-4 rounded bg-sky-500 text-white">
              Entrar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
